import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Sales.ContractRefundInvoice.GenerateInvoiceDocument.IRequest;
type Response = Api.Sales.ContractRefundInvoice.GenerateInvoiceDocument.IResponse;
type Headers = Api.Sales.ContractRefundInvoice.GenerateInvoiceDocument.IHeaders;
const url = '/api/Sales/ContractRefundInvoice/GenerateInvoiceDocument/:contractRefundInvoiceId';
export default async function contractRefundInvoiceGenerateInvoiceDocumentApi({
  contractRefundInvoiceId,
}: Request): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, { contractRefundInvoiceId }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
